"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidEducatorLinkType = void 0;
const AnalyticsError_1 = __importDefault(require("../AnalyticsError"));
class InvalidEducatorLinkType extends AnalyticsError_1.default {
    constructor() {
        super('invalid-educator-link-type', 'Invalid Link Type', undefined, 400);
    }
}
exports.InvalidEducatorLinkType = InvalidEducatorLinkType;
exports.default = InvalidEducatorLinkType;
